import React from 'react';
import Header from '../../components/admin/header';
import ContactList from '../../components/contactlist';

function Contacts() {
  return (
    <React.Fragment>
      <Header />
      <div className="text-center mt-5">
        <h2>Messages</h2>
      </div>
      <ContactList />
    </React.Fragment>
  );
}

export default Contacts;
